import { all } from 'redux-saga/effects';

// ── Global (org-level / reference data) ─────────────────────────────
import appSagas from 'reduxStore/app/saga';
import authSagas from 'reduxStore/auth/saga';
import organisationSaga from 'reduxStore/organisations/saga';
import sitesSagas from 'reduxStore/sites/saga';
import floorsSagas from 'reduxStore/floors/saga';
import categoriesSagas from 'reduxStore/categories/saga';
import defaultCategoriesSagas from 'reduxStore/defaultCategories/saga';
import settingsSagas from 'reduxStore/settings/saga';
import defaultSettingsSagas from 'reduxStore/defaultSettings/saga';
import typesSagas from 'reduxStore/types/saga';
import rolesSagas from 'reduxStore/roles/saga';
import mapSaga from 'reduxStore/maps/saga';
import FBRemoteConfigSagas from 'reduxStore/fbRemoteConfig/saga';
import billingSagas from 'reduxStore/billing/saga';
import siteTrialStaffSagas from 'reduxStore/siteTrialStaff/saga';
import demoSaga from 'reduxStore/demo/saga';
import approvalsSaga from 'reduxStore/approvals/saga';
import featureFlagsSaga from 'reduxStore/featureFlags/saga';
import notificationsSagas from 'reduxStore/notifications/saga';
import alertRulesSaga from 'reduxStore/alertRules/saga';
import alertInstancesSaga from 'reduxStore/alertInstances/saga';
import globalAlertRulesSaga from 'reduxStore/globalAlertRules/saga';
import slackSaga from 'reduxStore/slack/saga';
import auditLogsSaga from 'reduxStore/auditLogs/saga';
import reportsSaga from 'reduxStore/reports/saga';

// ── Shared: Access + Lockers (scoped by siteID) ────────────────────
import peopleSagas from 'reduxStore/people/saga';
import devicesSagas from 'reduxStore/devices/saga';
import camerasSagas from 'reduxStore/cameras/saga';

// ── Access product (scoped by siteID) ──────────────────────────────
import teamsSagas from 'reduxStore/teams/saga';
import assetGroupSagas from 'reduxStore/assetGroups/saga';
import credentialsSagas from 'reduxStore/credentials/saga';
import accessSagas from 'reduxStore/access/saga';
import accessWindowsSagas from 'reduxStore/accessWindows/saga';
import openAccessSagas from 'reduxStore/openAccess/saga';
import accessLogs from 'reduxStore/accessLogs/saga';
import innerRangeSagas from 'reduxStore/innerRange/saga';
import inceptionSagas from 'reduxStore/inception/saga';
import m365Sagas from 'reduxStore/m365/saga';
import controlSagas from 'reduxStore/control/saga';
import ttlockSagas from 'reduxStore/ttlock/saga';
import gatewaysSagas from 'reduxStore/gateways/saga';
import partnerSagas from 'reduxStore/partner/saga';
import partnerAdminSagas from 'reduxStore/partnerAdmin/saga';

// ── Lockers only ────────────────────────────────────────────────────
import bookingSagas from 'reduxStore/bookings/saga';
import bookableResourcesSagas from 'reduxStore/bookableResources/saga';
import dayPassesSagas from 'reduxStore/dayPasses/saga';
import visitsSagas from 'reduxStore/visits/saga';
import roomStaysSagas from 'reduxStore/roomStays/saga';
import cardStockSagas from 'reduxStore/cardStock/saga';
import maintenanceSagas from 'reduxStore/maintenance/saga';
import inventorySagas from 'reduxStore/inventory/saga';

function* rootSaga() {
	yield all([
		// ── Global ──────────────────────────────────────────────────
		appSagas(),
		authSagas(),
		organisationSaga(),
		sitesSagas(),
		floorsSagas(),
		categoriesSagas(),
		defaultCategoriesSagas(),
		settingsSagas(),
		defaultSettingsSagas(),
		typesSagas(),
		rolesSagas(),
		mapSaga(),
		FBRemoteConfigSagas(),
		billingSagas(),
		siteTrialStaffSagas(),
		demoSaga(),
		approvalsSaga(),
		featureFlagsSaga(),
		notificationsSagas(),
		alertRulesSaga(),
		alertInstancesSaga(),
		globalAlertRulesSaga(),
		slackSaga(),
		auditLogsSaga(),
		reportsSaga(),

		// ── Shared: Access + Lockers ────────────────────────────────
		peopleSagas(),
		devicesSagas(),
		camerasSagas(),

		// ── Access product ──────────────────────────────────────────
		teamsSagas(),
		assetGroupSagas(),
		credentialsSagas(),
		accessSagas(),
		accessWindowsSagas(),
		openAccessSagas(),
		accessLogs(),
		innerRangeSagas(),
		inceptionSagas(),
		m365Sagas(),
		controlSagas(),
		ttlockSagas(),
		gatewaysSagas(),
		partnerSagas(),
		partnerAdminSagas(),

		// ── Lockers only ────────────────────────────────────────────
		bookingSagas(),
		bookableResourcesSagas(),
		dayPassesSagas(),
		visitsSagas(),
		roomStaysSagas(),
		cardStockSagas(),
		maintenanceSagas(),
		inventorySagas()
	]);
}

export default rootSaga;
